export default defineNuxtRouteMiddleware((to) => {
  // TODO: Remove route guard before auth goes live.
  // Guard auth routes if env is not dev.
  if (["dev", "ci"].includes(process.env.NUXT_PUBLIC_APP_ENVIRONMENT)) {
    const authRoutes = [
      "/account",
      "/confirm",
      "/login",
      "/reset-password",
      "/sign-up",
    ]
    if (authRoutes.includes(to.path)) {
      return abortNavigation()
    }
  }
})
